export const ORDER_MODALITIES = {
  COMMON: 0,
  INVERSE_LOGISTIC: 1,
  REVERSE_LOGISTIC: 2,
};

export const ORDER_FORMART_LABEL = {
  letter: 'Carta',
  box: 'Caixa',
  roll: 'Cilindro / Rolo',
};

export const ORDER_STATUSES = {
  PENDING: 'pending',
  GENERATED: 'generated',
  EXPIRED: 'expired',
  RELEASED: 'released',
  POSTED: 'posted',
  DELIVERED: 'delivered',
  CANCELED: 'canceled',
  UNDELIVERED: 'undelivered',
  UNAUTHORIZED: 'unauthorized',
  SUSPENDED: 'suspended',
  RECEIVED: 'received',
  PAUSED: 'paused'
}
